module.exports = __webpack_public_path__ + "img/map_6.a1147c0b.png";